import { render } from "./BulkPriceTable.vue?vue&type=template&id=ae62441c"
import script from "./BulkPriceTable.vue?vue&type=script&lang=js"
export * from "./BulkPriceTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__